<template>
	<v-row>

		<template v-if="smAndDown">

			<v-col cols="12">

				<ui-box>

					<span class="font-weight-bold text-body-2">Redemption Stats</span>
					<v-divider class="my-2 opacity-70"></v-divider>

					<v-row class="justify-space-between" no-gutters>
						<v-col cols="auto">
							<div class="text-center text-h6">
								<span style="letter-spacing: -0.5px;">
									{{ stats.redemptionsYesterday.toLocaleString() }}
								</span>
								<span class="text-caption text-no-wrap">/ YEST</span>
							</div>
						</v-col>
						<v-col cols="auto">
							<div class="text-center text-h6">
								<span style="letter-spacing: -0.5px;">
									{{ stats.redemptionsToday.toLocaleString() }}
								</span>
								<span class="text-caption text-no-wrap">/ TOD</span>
							</div>
						</v-col>
						<v-col cols="auto">
							<div class="text-center text-h6">
								<span style="letter-spacing: -0.5px;">
									{{ stats.redemptionsThisMonth.toLocaleString() }}
								</span>
								<span class="text-caption text-no-wrap">/ MTD</span>
							</div>
						</v-col>
						<v-col cols="auto">
							<div class="text-center text-h6">
								<span style="letter-spacing: -0.5px;">
									{{ stats.redemptionsThisYear.toLocaleString() }}
								</span>
								<span class="text-caption text-no-wrap">/ YTD</span>
							</div>
						</v-col>
					</v-row>

				</ui-box>

			</v-col>

		</template>

		<template v-else>

			<v-col cols="6" md="3">
				<ui-box>
					<template v-slot:header>
						<div class="align-center d-flex">
							<div class="flex-grow-1">
								<v-icon>mdi-chart-line-variant</v-icon>
								<span class="font-weight-bold text-body-2">Yesterday</span>
							</div>
						</div>
					</template>
					<div class="text-h3 text-sm-h3 text-md-h2">
						{{ stats.redemptionsYesterday.toLocaleString() }}
					</div>
					<div>
						<v-divider class="mb-1 mt-2"></v-divider>
						<div class="grey--text text--darken-2 mt-2 text-caption">Redemptions</div>
					</div>
				</ui-box>
			</v-col>
			<v-col cols="6" md="3">
				<ui-box>
					<template v-slot:header>
						<div class="align-center d-flex">
							<div class="flex-grow-1">
								<v-icon>mdi-chart-line-variant</v-icon>
								<span class="font-weight-bold text-body-2">Today</span>
							</div>
						</div>
					</template>
					<div class="text-h3 text-sm-h3 text-md-h2">
						{{ stats.redemptionsToday.toLocaleString() }}
					</div>
					<div>
						<v-divider class="mb-1 mt-2"></v-divider>
						<div class="grey--text text--darken-2 mt-2 text-caption">Redemptions</div>
					</div>
				</ui-box>
			</v-col>
			<v-col cols="6" md="3">
				<ui-box>
					<template v-slot:header>
						<div class="align-center d-flex">
							<div class="flex-grow-1">
								<v-icon>mdi-chart-line-variant</v-icon>
								<span class="font-weight-bold text-body-2">This Month</span>
							</div>
						</div>
					</template>
					<div class="text-h3 text-sm-h3 text-md-h2">
						{{ stats.redemptionsThisMonth.toLocaleString() }}
					</div>
					<div>
						<v-divider class="mb-1 mt-2"></v-divider>
						<div class="grey--text text--darken-2 mt-2 text-caption">Redemptions</div>
					</div>
				</ui-box>
			</v-col>
			<v-col cols="6" md="3">
				<ui-box>
					<template v-slot:header>
						<div class="align-center d-flex">
							<div class="flex-grow-1">
								<v-icon>mdi-chart-line-variant</v-icon>
								<span class="font-weight-bold text-body-2">This Year</span>
							</div>
						</div>
					</template>
					<div class="text-h3 text-sm-h3 text-md-h2">
						{{ stats.redemptionsThisYear.toLocaleString() }}
					</div>
					<div>
						<v-divider class="mb-1 mt-2"></v-divider>
						<div class="grey--text text--darken-2 mt-2 text-caption">Redemptions</div>
					</div>
				</ui-box>
			</v-col>

		</template>

	</v-row>
</template>

<script>
export default {
	name: 'DashboardStats',
	props: {
		stats: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {};
	},
	computed: {
		smAndDown() {
			return this.$vuetify.breakpoint.smAndDown;
		}
	},
	methods: {}
};
</script>

<style lang="scss" scoped>
.month-icon {
	&::after {
		color: var(--v-bw-secondary-base);
		content: 'MO';
		font-size: 11px;
		font-weight: bold;
		left: 2px;
		position: absolute;
		text-align: center;
		top: 15px;
		width: 32px;
		z-index: 2;

		@media only screen and (max-width: 959.98px) {
			font-size: 7px;
			left: -4px;
			top: 11px;
		}
	}
}

.year-icon {
	&::after {
		color: var(--v-bw-secondary-base);
		content: 'YR';
		font-size: 11px;
		font-weight: bold;
		left: 2px;
		position: absolute;
		text-align: center;
		top: 15px;
		width: 32px;
		z-index: 2;

		@media only screen and (max-width: 959.98px) {
			font-size: 7px;
			left: -4px;
			top: 11px;
		}
	}
}
</style>
